module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN312_834466250.426e94cf.png";